import { Check } from "lucide-react";

const STEPS = ['Booked', 'Gated', 'Loaded', 'On Vessel', 'Arrived', 'Delivered'];

interface StepperProps {
  current: number; // 0-based index of current step (0 = Booked, 5 = Delivered)
  steps?: string[]; // optional custom steps
}

export function Stepper({ current, steps = STEPS }: StepperProps) {
  return (
    <div className="grid grid-cols-6 gap-1.5">
      {steps.map((s, i) => {
        const done = i < current;
        const active = i === current;
        return (
          <div key={s} className="relative flex flex-col items-center">
            {i < steps.length - 1 && (
              <span
                className={[
                  'absolute top-2.5 left-[55%] right-[-45%] h-0.5 rounded-full',
                  done ? 'bg-green-500' : active ? 'bg-gradient-to-r from-blue-500 to-gray-200' : 'bg-gray-200',
                ].join(' ')}
              />
            )}
            <span
              className={[
                'relative w-5 h-5 rounded-full flex items-center justify-center text-[9px] font-bold ring-2 ring-white',
                done && 'bg-green-500 text-white',
                active && 'bg-blue-600 text-white shadow-[0_0_0_4px_rgba(37,99,235,0.15)]',
                !done && !active && 'bg-gray-100 text-gray-400 ring-1 ring-gray-200',
              ].filter(Boolean).join(' ')}
            >
              {done ? <Check className="w-2.5 h-2.5" strokeWidth={3.5} /> : i + 1}
            </span>
            <span className={[
              'mt-1.5 text-[10px] text-center leading-tight',
              done ? 'text-gray-700' : active ? 'text-blue-700 font-semibold' : 'text-gray-400',
            ].join(' ')}>
              {s}
            </span>
          </div>
        );
      })}
    </div>
  );
}

export default Stepper;